import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsHighlightsViewedParams = {
  highlight_count: number;
  highlight_types: string[];
  trail_id: number;
};

/**
 * User scrolls to the Highlights section of the trail details page. Fires once per trail page visit when the section first goes into view (not when the section is 100% visible).
 * @param params - Attributes to log with the amplitude event
 * @param params.highlight_count - Number of highlights displayed in the Highlights section (0–4).
 * @param params.highlight_types - List of highlight types displayed in the Highlights section, in the order they were rendered (e.g., 'featured_in_guide', 'spotty_service', 'great_views', 'waterfalls'). Up to 4 entries.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsHighlightsViewed = (
  { highlight_count, highlight_types, trail_id }: logTrailDetailsHighlightsViewedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details highlights viewed',
    { 'highlight count': highlight_count, 'highlight types': highlight_types, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsHighlightsViewed;
